export default __webpack_public_path__ + "static/media/hero-three.2973fa27.jpg";